export const colors = {
  primary: '#ff5246',
  primary02: 'rgba(182, 215, 255, 0.2)',
  mainBg: '#F3F3F3',
  lightBg: '#FAFAFA',
  white: '#FFFFFF',
  black: 'rgba(0, 0, 0, 0.87)',
  trueBlack: '#000000',
  lightGray: 'rgba(33, 33, 33, 0.08)',
  lightGray02: '#00000012',
  loadingGray: '#bfbfbf',
  loadingSpiralGray: 'rgb(33 33 33 / 15%)',
  gray: 'rgba(0, 0, 0, 0.6)',
  darkGray: 'rgba(0, 0, 0, 0.38)',
  fontGray: 'rgba(0, 0, 0, 0.49)',
  purple: 'rgba(187, 134, 252, 0.38)',
  success: '#21AC2A',
  error: 'rgba(194, 0, 0, 1)',
  actionsTable: 'rgb(0,0,1)',
  overlayPrimary: 'rgba(30, 150, 250, 0.08)',
  overlayHover: 'rgba(0, 0, 0, 0.08)',
  chartLegend: 'rgba(0, 0, 0, 1)',
  cardAccordionBackgroundDefault: '#FFFFFF',
  cardAccordionBackgroundLightGreen: '#F4FFF5',
  cardAccordionBackgroundLightRed: '#FFF0F0',
  cardAccordionIconDefault: '#000000de',
  cardAccordionIconDefaultGreen: '#21AC2A',
  cardAccordionIconDefaultRed: '#C20000',
  closeButtonLightBlue: '#3980FF',
  planningGridAccordionSumaryBg: '#F9F9F9',
  statusCancelError: '#444444',
  statusPaused: '#FFE34C',
  lateStatus: '#FF7979',
  statusCompleted: '#87E78D',
  statusInProgress: '#CC9FFF',
  statusProgrammed: '#4365A8',
  statusMobile: '#D3D3D3',
  lightBlue: '#9EC2FF',
  inspectionChecklistReportTopBorder: '#FF5246',
  inspectionChecklistReportSectionBG: '#F9F9F9',
  inspectionChecklistReportFooterBG: '#F9F9F9',
  inspectionChecklistReportTableBorder: '#B6D7FF',
  uploadedItemLegend: 'rgba(0, 0, 0, 1)',
  equipmentGridBG: '#F9F9F9',
};

export const iconColor = (color: string): string => {
  const colorAux = color as keyof typeof iconColors;
  const iconColors = {
    [colors.cardAccordionBackgroundDefault]: colors.cardAccordionIconDefault,
    [colors.cardAccordionBackgroundLightGreen]:
      colors.cardAccordionIconDefaultGreen,
    [colors.cardAccordionBackgroundLightRed]:
      colors.cardAccordionIconDefaultRed,
    default: colors.black,
  };
  return iconColors[colorAux] || iconColors.default;
};
